/**
 * Performs DTM direct call tracking
 *
 * @param {string} name - the direct call name
 * @param {obj} dataLayerProperties - values that we want to add to the data layer to set as eVars
 */
const aaTrackEvent = (name, dataLayerProperties = null) => {
  if (!window._satellite) {
    return;
  }

  if (dataLayerProperties !== null) {
    if (window.webDigitalData) {
      window.webDigitalData = {
        ...window.webDigitalData,
        direct_call: dataLayerProperties,
      };
    }
  }

  window._satellite.track(name);
};

export default aaTrackEvent;
